import Icon from "@ant-design/icons";
import { Button, Col, Row } from "antd";

import { createDiscordUrl } from "../../utils/constants";

const AddDiscord = (props) => {
  const addToDiscord = (
    <Row justify={props.justify || "start"}>
      <Col span={12}>
        <a className="add-slack" href={createDiscordUrl("oauth")}>
          <Button
            size="large"
            icon={
              <Icon
                component={() => (
                  <img src="/discord.svg" alt="discord" width="18" />
                )}
              />
            }
          >
            Add to Discord
          </Button>
        </a>
      </Col>
    </Row>
  );

  return <div>{addToDiscord}</div>;
};

export default AddDiscord;
